import { ApolloClient } from 'apollo-client'
import { createUploadLink } from 'apollo-upload-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { Observable } from 'apollo-link'
import { setContext } from 'apollo-link-context'
import { onError } from 'apollo-link-error'
import { logOut, getRefreshToken, loginFunc } from '@/services/auth'
import Vue from 'vue'
// Also works for the HTTP connection to the API in place of HttpLink
const link = createUploadLink({ uri: process.env.VUE_APP_GRAPHQL_ENDPOINT_HTTP })

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('accessToken')
  const { visitorId } = Vue?.$eh?.visitorId || ''
  const _headers =
    process.env.NODE_ENV === 'production'
      ? { ...headers }
      : {
        ...headers,
        'x-request-id': Math.ceil(Math.random() * Math.pow(10, 7)).toString(16),
        'x-client-id': visitorId
      }
  if (headers && Object.prototype.hasOwnProperty.call(headers, 'execution-context')) {
    return {
      headers: {
        ..._headers,
        authorization: `Bearer ${token}`
      }
    }
  } else {
    return {
      headers: {
        'execution-context': 'admin',
        ..._headers,
        authorization: `Bearer ${token}`
      }
    }
  }
})

const refreshLink = onError(({ graphQLErrors, operation, forward }) => {
  if (graphQLErrors) {
    for (const err of graphQLErrors) {
      if (err.extensions.code === 'UNAUTHENTICATED') {
        return promiseToObservable(refreshToken(operation)).flatMap(() =>
          forward(operation)
        )
      }
      if (err.extensions.code === 'FORBIDDEN') {
        Vue.$eh.$emit('snackbar', {
          color: 'error',
          text: 'Недостаточно прав для данного действия'
        })
      }
    }
  }
})

// Create the apollo client
const apolloClient = new ApolloClient({
  link: refreshLink.concat(authLink.concat(link)),
  cache: new InMemoryCache(),
  connectToDevTools: true
})

export default apolloClient

const promiseToObservable = promise =>
  new Observable(subscriber => {
    promise.then(
      value => {
        if (subscriber.closed) return
        subscriber.next(value)
        subscriber.complete()
      },
      err => subscriber.error(err)
    )
    return subscriber
  })

const refreshToken = operation => {
  return fetch(`${process.env.VUE_APP_REST_API_BASE}/auth/refresh`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      refreshToken: getRefreshToken()
    })
  })
    .then(o => o.json())
    .then(refreshJson => {
      if (refreshJson.status >= 400) throw new Error(refreshJson.reason)

      loginFunc(refreshJson)

      operation.setContext({
        headers: {
          ...operation.getContext().headers,
          authorization: refreshJson.accessToken
        }
      })
    })
    .catch(() => logOut())
}
